import { Tooltip } from '@rocket/ui';
import type { ReactNode } from 'react';

export interface TooltipCustomProps {
  title: string;
  children?: ReactNode;
}

export const TooltipCustom = ({ title, children = null }: TooltipCustomProps) => {
  const lines = title.split('\\n');
  return (
    <Tooltip hasArrow trigger={<div>{children}</div>}>
      <div style={{ display: 'flex', flexDirection: 'column', color: 'var(--chakra-colors-bg)' }}>
        {lines.map((text, idx) => (
          <div key={`t-${idx}`} style={{ fontSize: '14px' }}>
            {text}
          </div>
        ))}
      </div>
    </Tooltip>
  );
};
